import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import clsx from 'clsx';
import React from 'react';

import { filterByPlAndAttrField } from "../utils";
import { createStyles } from "./styles";







var ProductTiles = function ProductTiles(_ref)




{var _context;var productLineAttrs = _ref.productLineAttrs,productAttrs = _ref.productAttrs,productLine = _ref.productLine,_ref$styles = _ref.styles,styles = _ref$styles === void 0 ? '' : _ref$styles;
  var classes = createStyles();
  var AttrItems = _mapInstanceProperty(_context = filterByPlAndAttrField(productLineAttrs, 'planTile', productLine)).call(_context,
  function (_ref2) {var _productAttrs$find;var displayName = _ref2.displayName,id = _ref2.id;
    // get attribute value from the list of all product attributes
    var currentProductAttrValue =
    ((_productAttrs$find = _findInstanceProperty(productAttrs).call(productAttrs, function (_ref3) {var attributeId = _ref3.attributeId;return attributeId === id;})) === null || _productAttrs$find === void 0 ? void 0 : _productAttrs$find.displayValue) || '';

    return /*#__PURE__*/(
      React.createElement(React.Fragment, { key: id },
      currentProductAttrValue ? /*#__PURE__*/
      React.createElement("li", { className: classes.attributeWrapper }, /*#__PURE__*/
      React.createElement("span", { className: classes.planTileName }, displayName), /*#__PURE__*/
      React.createElement("span", { className: classes.planTileValue }, currentProductAttrValue)) : /*#__PURE__*/


      React.createElement(React.Fragment, null)));



  });

  return /*#__PURE__*/React.createElement("ul", { className: clsx(classes.planTiles, styles) }, AttrItems);
};

export default ProductTiles;
//# sourceMappingURL=index.js.map